export { default } from './use-on-click-outside';
